import React, { useEffect, useState, useRef } from 'react';

function PartnerStart() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full flex justify-center bg-white py-24 md:py-[160px]">
      <div className="w-full flex flex-col items-center space-y-[48px]">
        {/* 메인 텍스트 */}
        <h2 className={`text-[24px] md:text-[40px] font-pretendard font-medium text-black leading-[140%] text-center transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <span className="md:hidden">
            새로운 수익과<br />유통 구조를 연결하는 플랫폼,<br />폰피쉬 파트너 안경점으로<br />시작하세요.
          </span>
          <span className="hidden md:inline">
            새로운 수익과 유통 구조를 연결하는 플랫폼,<br />폰피쉬 파트너 안경점으로 시작하세요.
          </span>
        </h2>

        {/* 버튼 영역 */}
        <div className={`flex flex-col md:flex-row items-center gap-4 md:gap-8 transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <a href="https://ponpish.notion.site/238d3c74a75880bd95cee736702f8a5f?pvs=105" target="_blank" rel="noopener noreferrer">
            <button className="bg-[#973BEE] text-white px-12 py-4 rounded-full font-semibold text-[18px] md:text-[22px] shadow-lg shadow-[inset_0_2px_4px_rgba(255,255,255,0.3)] hover:opacity-90 transition whitespace-nowrap w-[280px] md:w-auto">
              신규 입점 신청하기 →
            </button>
          </a>
          <a href="https://pf.kakao.com/_IZxkxin/chat" target="_blank" rel="noopener noreferrer">
            <button className="bg-black text-white px-12 py-4 rounded-full font-semibold text-[18px] md:text-[22px] shadow-lg shadow-[inset_0_2px_4px_rgba(255,255,255,0.3)] hover:opacity-90 transition whitespace-nowrap w-[280px] md:w-auto">
              문의하기 →
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}

export default PartnerStart; 